import { useCallback } from 'react'
import { useSnackbar } from '@ui/snackbar'
import { isPointerModifierPressed } from 'src/shortcuts/pointerModifiers'

const useMultiSelectionEvent = () => {
  const { enqueueSnackbar } = useSnackbar()

  return useCallback(
    (
      guid: string,
      selectedElements: string[],
      addElement: (guid: string) => void,
      removeElement: (guid: string) => void,
      shouldBeAdded: (elementGuid: string, selectedElements: string[]) => boolean,
    ) => {
      const isMultiSelectPressed = isPointerModifierPressed('multiSelect')
      if (isMultiSelectPressed) {
        if (selectedElements.includes(guid)) {
          removeElement(guid)
        } else if (shouldBeAdded(guid, selectedElements)) {
          addElement(guid)
        } else
          enqueueSnackbar({
            message:
              'Das Element kann nicht zur bestehenden Auswahl hinzugefügt werden (z.B. weil man Dächer nicht zusammen mit Unterzügen editieren kann)',
            variant: 'info',
            preventDuplicate: false,
          })

        return true
      }
      return false
    },
    [enqueueSnackbar],
  )
}

export default useMultiSelectionEvent
